<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/calendar/scheme/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('rilifanganmingcheng')">
						<el-input v-model="yt.conditions.name"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button v-if="utils.checkPower('web_scheduling_calendar_plan_create')" size="mini" @click="yt.showEditDialog('xinzeng',null,'w1');setAddEnable()" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<!-- <template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
				</el-button>
			</template> -->
			<!-- 自定义某个字段 -->

			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button v-if="utils.checkPower('web_scheduling_calendar_plan_update')" type="text" @click="yt.showEditDialog('bianji', scope.row,'w1')">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button v-if="utils.checkPower('web_scheduling_calendar_plan_get_item')" type="text"
							@click="yt.showEditDialog('chakanxiangqing', scope.row,'80%')">{{$t('chakanxiangqing')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text"
							@click="yt.showEditDialog('tingchanjihua', scope.row,'80%')">{{$t('tingchanjihua')}}
						</el-button>
					</el-col>

					<el-col :span="0.1">
						<el-button v-if="utils.checkPower('web_scheduling_calendar_plan_delete')" type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/calendar/scheme/delete')">
							{{$t('shanchu')}}
						</el-button>
					</el-col>

				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<!-- <div class="dialog-scroller"> -->
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('rilifanganmingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('banzhimingcheng')" required>
						<el-select v-model="yt.editObj.shiftTypeId">
							<el-option v-for="shift in shifts" :label="$t(shift.name)" :value="shift.id"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<!-- </div> -->
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
						@click="yt.req('POST','/web/calendar/scheme/create')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('rilifanganmingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('banzhimingcheng')" required>
						<el-select v-model="yt.editObj.shiftTypeId">
							<el-option v-for="shift in shifts" :label="$t(shift.name)" :value="shift.id"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
						@click="yt.req('POST','/web/calendar/scheme/update')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 停产计划 -->
			<template v-if="yt.editObj.action == 'tingchanjihua'">
				<div class="dialog-scroller">
					<stop_production :calendarSchemeId="yt.editObj.id"></stop_production>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<!-- <el-button :loading="yt.editObj.loading" size="mini"
						@click="editCustomerType" type="primary">
						{{$t('baocun')}}
					</el-button> -->
				</span>
			</template>
			<!-- 查看详情 -->
			<template v-if="yt.editObj.action == 'chakanxiangqing'">
				<div class="dialog-scroller">
					<plan_detail v-if="yt.isShowEditDialog" :calendarSchemeId="yt.editObj.id"></plan_detail>
				</div>
				
			</template>


		</el-dialog>
	</div>
</template>
<!-- /quality/inspection/standard/details/get -->
<script type="text/javascript">
	import stop_production from '@@/pages/web/scheduling/calendar_plan/stop_production/list.vue'
	import plan_detail from '@@/pages/web/scheduling/calendar_plan/plan_detail/index.vue'
	export default {
		name: 'web_scheduling_calendar_plan_list',
		components: {
			stop_production,
			plan_detail,
		},
		data() {
			return {
				shifts: [],
				columns: [{
					label: 'rilifanganmingcheng',
					prop: 'name',
				}, {
					label: 'banzhi',
					prop: 'shiftType.name',

				}, {
					label: 'chuangjianren',
					prop: 'createByObject.nickname',
				}, {
					label: 'chuangjianshijian',
					prop: 'createTime',
					type: 'time',
					format: 'YYYY-MM-DD'
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 250,
					fixed: 'right'
				}]
			};
		},
		created() {
			this.getShiftType()
			setTimeout(() => {
				this.yt.get(1);
			}, 300)

		},

		methods: {
			getShiftType() {
				this.http.get('/web/setting/shiftType/list').then((res) => {
					this.shifts = res.data
				}).catch((msg) => {
					this.utils.errorMessage(msg);
				})
			},


		}
	};
</script>